import BaseModel from './BaseModel';

/** Class representing a resource. */
class Resource extends BaseModel {}

export default Resource;
